<template>
  <table class="matrixAll">
    <tr class="headRow" v-if="isMatrixSingle">
      <th class="fixedText"></th>
      <th
        v-for="(item, index) in currentAnswerConfigArray"
        class="chooseText"
        :key="index"
      >
        <span style="white-space: pre-wrap">
          {{ $filters.breakLine(translate[item.id]) }}
        </span>
      </th>
    </tr>
    <tbody
      class="bodyRow"
      v-for="(row, rowIndex) in currentAnswerConfig.rowTitleArray"
      :key="rowIndex"
    >
      <tr>
        <td class="subTitle" :colspan="currentAnswerConfigArray.length + 1">
          <p class="text" style="white-space: pre-wrap">
            {{ $filters.breakLine(translate[row.id]) }}
          </p>
          <img
            class="previewPic"
            v-if="row.picUrl"
            :src="row.picUrl"
            alt="previewPic"
          />
        </td>
      </tr>
      <tr class="chooseArray">
        <td v-if="isMatrixSingle"></td>
        <td
          class="choose"
          v-for="(num, chooseIndex) in currentAnswerConfigArray"
          :key="num"
          @click="matrixEvent(rowIndex, chooseIndex)"
        >
          <div
            class="decorator"
            :class="[
              {
                active: isMatrixSingle
                  ? chooseIndex === matrixAnswerArray[rowIndex]
                  : chooseIndex <= matrixAnswerArray[rowIndex],
              },
              isMatrixSingle ? 'point' : 'rating',
              currentButtonType,
            ]"
          >
            <span v-if="currentButtonType === 'number'">{{
              translate[num.id] || num.score
            }}</span>
          </div>
        </td>
      </tr>
      <tr
        v-if="currentAnswerConfigArray[matrixAnswerArray[rowIndex]]?.allowEdit"
        class="inputRow"
      >
        <td :colspan="currentAnswerConfigArray.length + 1">
          <input
            class="input"
            :placeholder="$t('opinion')"
            v-model="commonAnswerInfo[rowIndex].edit"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts" setup>
import answerHook from "../../hooks/answerHook";
import { useTextareaAutosize } from "@vueuse/core";
const { textarea, input } = useTextareaAutosize();
const {
  currentAnswerConfig,
  matrixEvent,
  currentAnswerConfigArray,
  isMatrixSingle,
  matrixAnswerArray,
  currentButtonType,
  translate,
  commonAnswerInfo,
} = answerHook();
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.matrixAll {
  position: relative;
  width: 100%;
  color: #333;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0 20px;
  margin-top: -10px;
  @media screen and (orientation: landscape) {
    border-spacing: 0 20px;
  }
  .choose {
    padding: 10px;
    @media screen and (orientation: landscape) {
      padding: 10px;
    }
  }
  tr {
    width: 100%;
  }
  th,
  td {
    text-align: left;
    font-size: 20px;
    line-height: 1.2;
    @media screen and (orientation: landscape) {
      font-size: 22px;
    }
  }
  .chooseText {
    font-weight: 600;
  }
  .subTitle {
    text-align: left;
  }
  .fixedText {
    @media screen and (orientation: landscape) {
      width: 120px;
    }
    @media screen and (orientation: portrait) {
      width: 30px;
    }
  }
  .bodyRow {
    line-height: 22px;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    @media screen and (orientation: landscape) {
      line-height: 22px;
      padding: 20px;
    }
    .text {
      font-size: 22px;
      align-self: flex-start;
      line-height: 30px;
      @media screen and (orientation: landscape) {
        font-size: 22px;
        line-height: 30px;
      }
    }
  }
  .inputRow {
    position: relative;
    top: -20px;
    @media screen and (orientation: landscape) {
      top: -20px;
    }
  }
  .input {
    font-size: 14px;
    height: 45px;
    padding-left: 20px;
    margin: 20px 0;
    background: #f7f7f7;
    width: 92%;
    border-radius: 8px;
    @media screen and (orientation: landscape) {
      font-size: 14px;
      height: 45px;
      padding-left: 20px;
      margin: 20px 0;
      border-radius: 8px;
    }
  }
  .point {
    display: inline-block;
    cursor: pointer;
    @include setBackground(30px, 30px, "choose.png");
    background-size: 100% 100%;
    @media screen and (orientation: landscape) {
      width: 30px;
      height: 30px;
    }
    &.active {
      background-image: url($imgURL + "choose_active.png");
    }
  }
}
</style>
